namespace GeniuzPOS.Product {
    export interface CsSizeForm {
        SizeId: Serenity.StringEditor;
        SizeName: Serenity.StringEditor;
    }

    export class CsSizeForm extends Serenity.PrefixedContext {
        static formKey = 'Product.CsSize';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CsSizeForm.init)  {
                CsSizeForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(CsSizeForm, [
                    'SizeId', w0,
                    'SizeName', w0
                ]);
            }
        }
    }
}
